import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { logger } from '../../helpers/logger.helper';

const key = (userId: string) => `has_seen_create_walkthrough_${userId}`;
const wcBridgeKey = (userId: string) => `has_seen_wc_to_arena_bridge_${userId}`;
const wcFirstPickKey = (userId: string) => `has_made_wc_first_pick_${userId}`;

async function readFlag(storageKey: string): Promise<boolean> {
  try {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      return localStorage.getItem(storageKey) === 'true';
    }
    const value = await AsyncStorage.getItem(storageKey);
    return value === 'true';
  } catch (error) {
    if (__DEV__) logger.warn('walkthroughSeenStorage: read failed', { storageKey, error });
    return false;
  }
}

async function writeFlag(storageKey: string): Promise<void> {
  try {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      localStorage.setItem(storageKey, 'true');
      return;
    }
    await AsyncStorage.setItem(storageKey, 'true');
  } catch (error) {
    if (__DEV__) logger.warn('walkthroughSeenStorage: write failed', { storageKey, error });
  }
}

export async function hasSeenCreateWalkthrough(userId: string): Promise<boolean> {
  return readFlag(key(userId));
}

export async function markCreateWalkthroughSeen(userId: string): Promise<void> {
  return writeFlag(key(userId));
}

/** True once the post-first-pick "try our other games" bridge has been dismissed or accepted. */
export async function hasSeenWcToArenaBridge(userId: string): Promise<boolean> {
  return readFlag(wcBridgeKey(userId));
}

export async function markWcToArenaBridgeSeen(userId: string): Promise<void> {
  return writeFlag(wcBridgeKey(userId));
}

/** True once the user has made at least one World Cup pick. Used to gate first-pick triggers. */
export async function hasMadeWcFirstPick(userId: string): Promise<boolean> {
  return readFlag(wcFirstPickKey(userId));
}

export async function markWcFirstPickMade(userId: string): Promise<void> {
  return writeFlag(wcFirstPickKey(userId));
}
